package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.text.style.TextAlign
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

import kotlin.text.toString
import org.jetbrains.compose.web.attributes.InputType // <-- ¡LA LÍNEA DE CÓDIGO VICTORIOSA!
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Administrador
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import kotlin.js.Date
@Composable
private fun FilterSectionKPIs(
    uiState: AdminPanelUiState,
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Row)
            gap(16.px)
            padding(16.px)
            backgroundColor(Color("#f2f2f2"))
            borderRadius(8.px)
            alignItems(AlignItems.Center)
            width(100.percent)
            boxSizing("border-box")
        }
    }) {
        // --- ¡GRUPO #1: AÑO PRINCIPAL! ---
        B { Text("Año Principal:") }
        // Este selector ahora está fijo en 2026, pero podría ser dinámico en el futuro.
        Select(attrs = {
            style { padding(8.px); fontSize(14.px); color(Color.gray) }
            // Deshabilitado por ahora, ya que solo analizamos el año en curso
            attr("disabled", "true")
        }) {
            Option(value = "2026", attrs = { selected() }) { Text("2026") }
        }

        // --- ¡GRUPO #2: PERÍODO DE ANÁLISIS (AHORA DINÁMICO)! ---
        B { Text("Período de Análisis:") }
        Select(attrs = {
            style { padding(8.px); fontSize(14.px) }
            onChange { event -> viewModel.onKpiPeriodoChanged(event.target.value) }
        }) {
            // ¡VICTORIA! Se llena con la lista dinámica del ViewModel
            uiState.kpiPeriodosDisponibles.forEach { periodo ->
                Option(
                    value = periodo.id,
                    attrs = { if (periodo.id == uiState.kpiPeriodoSeleccionado) selected() }
                ) { Text(periodo.nombre) }
            }
        }

        // --- ¡GRUPO #3: AÑO DE COMPARACIÓN! ---
        B { Text("Comparar con:") }
        Select(attrs = {
            style { padding(8.px); fontSize(14.px) }
            onChange { event -> viewModel.onKpiAnioChanged("comparacion", event.target.value.toInt()) }
        }) {
            (2025 downTo 2021).forEach { anio ->
                Option(
                    value = anio.toString(),
                    attrs = { if (anio == uiState.kpiAnioComparacion) selected() }
                ) { Text(anio.toString()) }
            }
        }

        // --- Botón de Acción ---
        Button(attrs = {
            onClick { viewModel.onCalcularKpisClicked() }
            style { padding(10.px, 20.px); fontWeight("bold"); cursor("pointer"); backgroundColor(Color("#34A853")); color(Color.white); borderRadius(8.px) }
        }) { Text("Analizar") }

        Div({ style { flex(1) } }) // El soldado invisible

        Button(attrs = {
            onClick { onBack() }
            style { padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white); backgroundColor(Color("#FB8C00")); borderWidth(0.px); borderRadius(8.px) }
        }) { Text("Volver al Panel") }
    }
}


@Composable
fun DashboardSeguridadScreen(
    uiState: AdminPanelUiState,
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    val uiState by viewModel.uiState.collectAsState()

    Div({
        style {
            height(95.vh)
            backgroundColor(Color("#1976D2"))
            borderRadius(12.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            property("overflow", "hidden")
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                property("border-bottom", "2px solid #1565C0")
            }
        }) {
            Div({
                style {
                    width(15.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex);
                        flexDirection(FlexDirection.Column);
                        alignItems(AlignItems.Center);
                        gap(8.px)
                    } }) {
                    Img(src = "logo_icon.svg",
                        attrs = { style { height(120.px) } })
                    H2({
                        style { fontSize(24.px); color(Color.white); margin(0.px); property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                        Span({
                            style { fontWeight("normal") } }) { Text("Linea") }
                        Span({
                            style { fontWeight("bold") } }) { Text("Muni") }
                    }
                    P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                }
            }

            Div({
                style {
                    width(85.percent);
                    padding(16.px, 24.px);
                    boxSizing("border-box")
                    display(DisplayStyle.Flex);
                    flexDirection(FlexDirection.Column);
                    gap(16.px)
                }
            }) {
                H1({
                    style {
                        color(Color.white);
                        fontSize(32.px);
                        fontWeight(700);
                        flex(1);
                        textAlign("center");
                        margin(0.px);
                        paddingTop(20.px)
                    }
                }) { Text("INDICES KPIs PLAN COMUNAL SEGURIDAD") }

                FilterSectionKPIs(uiState, viewModel, onBack)
            }
        }

        Div({
            style {
                flex(1) // Ocupa todo el espacio restante
                overflowY("auto") // Permite el scroll vertical
                padding(24.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(32.px) // Espacio vertical entre las dos grandes secciones
                backgroundColor(Color("#1976D2"))
            }
        }) {
            // --- ¡VICTORIA! LLAMAMOS A LAS UNIDADES EN EL ORDEN CORRECTO ---

            // 1. La sección táctica, arriba, relacionada con los filtros.
            KpiTacticalSection(uiState)

            // 2. Una línea divisoria para la claridad visual.
            Hr({ style { width(95.percent); border(0.px); property("border-top", "2px solid #B0BEC5") } })

            // 3. La sección histórica, abajo, como un anuario fijo.
            KpiHistoricalSection(uiState)
        }

  ///////////////////////////////////////////

    }
}

            // --- Componente reutilizable para cada tarjeta de KPI ---
            @Composable
            fun KpiCard(
                titulo: String,
                valor: String,
                subtexto: String = "",
                variacion: Double,
                esLogicaInversa: Boolean = false
            ) {
                // 1. Determinamos el color (lógica dual que ya funciona)
                val valorColor = when {
                    esLogicaInversa && variacion > 0 -> Color("#34A853")
                    esLogicaInversa && variacion < 0 -> Color("#D93025")
                    !esLogicaInversa && variacion > 0 -> Color("#D93025")
                    !esLogicaInversa && variacion < 0 -> Color("#34A853")
                    else -> Color("#5f6368")
                }

                // 2. Determinamos el símbolo y el texto a mostrar.
                val simbolo = when {
                    variacion > 0.01 -> "+"
                    else -> "" // El signo negativo ya viene incluido en el número.
                }

                // 3. Formateamos el valor para asegurar consistencia.
                val valorFormateado = "$simbolo${variacion.toFixed(1)}%"
                // El Div principal de la tarjeta
                Div(attrs = {
                    classes(DashboardStylesheet.kpiCard)
                    style {
                        // ¡NUEVA ORDEN! Borde sutil
                        border(1.px, LineStyle.Solid, Color("#DADCE0"))
                    }
                }) {
                    // Contenedor interno para centrar todo
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.Center) // ¡VICTORIA! Centra todo horizontalmente
                            gap(4.px) // Un pequeño espacio entre los textos
                        }
                    }) {
                        H3({
                            style {
                                margin(8.px)
                                color(Color("#5f6368"))
                                fontSize(18.px)
                                textAlign("center") // Asegura que el título esté centrado si es muy largo
                            }
                        }) { Text(titulo.uppercase()) }

                        P({
                            style {
                                margin(8.px)
                                fontSize(48.px)
                                fontWeight("bold")
                                color(valorColor)
                            }
                        }) { Text(valor) }

                        if (subtexto.isNotBlank()) {
                            P({
                                style {
                                    margin(8.px)
                                    color(Color("#888"))
                                    fontStyle("italic")
                                    fontSize(14.px)
                                }
                            }) { Text(subtexto) }
                        }
                    }
                }
            }


// --- Componente reutilizable para cada tarjeta de KPI ---


@Composable
fun KpiHistoricoCard(kpi: KpiDetallado) {
    // Usamos la misma clase de estilo para la base (ancho, sombra, etc.)
    Div(attrs = {
        classes(DashboardStylesheet.kpiCard)
        style {
            border(1.px, LineStyle.Solid, Color("#DADCE0"))
            alignItems(AlignItems.Center)
        }

    }) {
        // --- ¡CONTENEDOR INTERNO RESTAURADO! ---
        // Añadimos un Div interno que controla el padding y la alineación.
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center) // Centra todo
                gap(8.px) // Espacio entre elementos
                padding(16.px)

            }
        }) {
            // Título del Delito
            H3({
                style {
                    marginTop(0.px)
                    marginBottom(8.px)
                    color(Color("#5f6368"))
                    fontSize(16.px)
                    textAlign("center")
                    //                textTransform("uppercase")
                }
            }) { Text(kpi.nombre) }

        }




            // Contenedor para las filas del historial
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(12.px) // Un poco más de espacio entre las filas del historial
                    width(220.px)
                    textAlign("center")
                    paddingLeft(80.px)
                }
            }) {
                // ¡LA MISMA LÓGICA DE CONCIENCIA DE CONTEXTO!
                val esVif = kpi.nombre.contains("VIF", ignoreCase = true)
                // Iteramos sobre la lista de variaciones históricas
                kpi.historicoAnual.forEach { variacionAnual ->
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            width(100.percent)
                            alignItems(AlignItems.Center)
                        }
                    }) {
                        Span({
                            style {
                                fontSize(16.px) } })
                        { Text("${variacionAnual.periodo}:") }

                        Div({
                            style {
                                flex(1)
                            }
                        })

                        // --- ¡EL SEMÁFORO INTELIGENTE DUAL! ---
                        val colorVariacion = when {
                            esVif && variacionAnual.variacion > 0 -> Color("#34A853") // VIF aumenta -> BUENO (Verde)
                            esVif && variacionAnual.variacion < 0 -> Color("#D93025") // VIF disminuye -> MALO (Rojo)
                            !esVif && variacionAnual.variacion > 0 -> Color("#D93025") // Otro delito aumenta -> MALO (Rojo)
                            !esVif && variacionAnual.variacion < 0 -> Color("#34A853") // Otro delito disminuye -> BUENO (Verde)
                            else -> Color("#5f6368")
                        }

                        val simbolo = when {
                            variacionAnual.variacion > 0.01 -> "+"
                            else -> "" // El signo negativo ya viene con el número
                        }

                        Span({
                            style {
                                fontWeight("bold")
                                color(colorVariacion)
                                fontSize(16.px)
                            }
                        }) { Text("$simbolo${variacionAnual.variacion.toFixed(1)}%") }

                }
            }
        }
    }
}

// --- ¡NUEVA UNIDAD DE ÉLITE PARA EL ANÁLISIS TÁCTICO! ---

@Composable
private fun KpiTacticalSection(uiState: AdminPanelUiState) {
    H2({
        style {
            color(Color.white);
            paddingLeft(16.px);
            margin(0.px, 0.px, 16.px, 0.px)
        } })
    { Text("Análisis Comparativo % de variación 2026 con igual periodo 2025") }
    Div({
        style {
            display(DisplayStyle.Flex);
            flexWrap(FlexWrap.Wrap);
            gap(8.px)
            justifyContent(JustifyContent.Center);
            backgroundColor(Color.white);
            borderRadius(8.px);
            padding(12.px)
        }
    }) {
        if (uiState.isLoading) {
            H3 { Text("Calculando KPIs...") }
        } else if (uiState.dashboardKpis != null) {
            val kpis = uiState.dashboardKpis
            KpiCard("KPI 1: Infracción Ley de Drogas", "${kpis.kpiDrogas.variacion.toFixed(1)}%", "Actual: ${kpis.kpiDrogas.valorActual.toInt()} | Ant: ${kpis.kpiDrogas.valorAnterior.toInt()}", kpis.kpiDrogas.variacion)
            KpiCard("KPI 2: Robos (Violencia o Intimidación)", "${kpis.kpiRobos.variacion.toFixed(1)}%", "Actual: ${kpis.kpiRobos.valorActual.toInt()} | Ant: ${kpis.kpiRobos.valorAnterior.toInt()}", kpis.kpiRobos.variacion)

            KpiCard(
                titulo = "CASOS TOTALES POR VIF",
                valor = "${kpis.kpiVif.variacion.toFixed(1)}%",
                subtexto = "Aprehensiones en período: ${kpis.kpiVifDetenidos.toInt()}",
                variacion = kpis.kpiVif.variacion,
                esLogicaInversa = true // VIF es un KPI que queremos que DISMINUYA, por lo tanto, la lógica de color es inversa.
            )
            KpiCard("KPI 4: Amenazas S.Norte", "${kpis.kpiAmenazas.variacion.toFixed(1)}%", "Actual: ${kpis.kpiAmenazas.valorActual.toInt()} | Ant: ${kpis.kpiAmenazas.valorAnterior.toInt()}", kpis.kpiAmenazas.variacion)
            KpiCard("KPI 5: Consumo Alcohol Vía Pública", "${kpis.kpiEbriedad.variacion.toFixed(1)}%", "Actual: ${kpis.kpiEbriedad.valorActual.toInt()} | Ant: ${kpis.kpiEbriedad.valorAnterior.toInt()}", kpis.kpiEbriedad.variacion)
        } else {
            H3 { Text("Seleccione un período y presione Analizar.") }
        }
    }
}


// --- ¡NUEVA UNIDAD DE ÉLITE PARA EL ANUARIO HISTÓRICO! ---
@Composable
private fun KpiHistoricalSection(uiState: AdminPanelUiState) {

    H2({
        style {
            color(Color.white);
            paddingLeft(16.px);
            margin(0.px, 0.px, 16.px, 0.px)
        } }) { Text("Variaciones % Históricas (datos CEAD)") }
    Div({
        style {
            display(DisplayStyle.Flex);
            flexWrap(FlexWrap.Wrap);
            gap(16.px) // Un gap generoso para separar las tarjetas
            justifyContent(JustifyContent.Center);
            backgroundColor(Color.white); // Fondo blanco
            borderRadius(8.px);
            paddingTop(24.px)
            paddingBottom(24.px)
        }
    }) {
        if (uiState.isLoadingHistoricos) {
            H3 { Text("Cargando historial...") }
        } else if (uiState.kpisDetallados.isNotEmpty()) {
            uiState.kpisDetallados.forEach { kpi ->
                KpiHistoricoCard(kpi)
            }
        } else {
            H3 { Text("No hay datos históricos para mostrar.") }
        }
    }
}



// Pequeña extensión para formatear números decimales
private fun Double.toFixed(digits: Int): String = this.asDynamic().toFixed(digits)

// ... al final del fichero, después de la última función ...

// --- NUESTRO LIBRO DE ESTILOS TÁCTICOS ---
object DashboardStylesheet : StyleSheet() {
    // 1. Creamos un nombre para nuestra clase de estilo
    val kpiCard by style {
        // 2. Ponemos TODOS los estilos base aquí
        width(280.px)
        backgroundColor(Color.white)
        borderRadius(12.px)
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
        property("box-shadow", "0px 4px 12px rgba(0,0,0,0.15)")
        property("transition", "transform 0.2s ease-in-out")
        border(2.px, LineStyle.Solid, Color("#DADCE0"))
    }

    val kpiHistoricoCard by style {
        width(280.px) // Mismo ancho para uniformidad
        backgroundColor(Color.white)
        borderRadius(12.px)
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(11.px) // Mantenemos el gap original que funcionaba para esta tarjeta
        property("box-shadow", "0px 4px 12px rgba(0,0,0,0.15)")
        property("transition", "transform 0.2s ease-in-out")
        border(2.px, LineStyle.Solid, Color("#DADCE0"))
    }
}

// --- ¡NUESTRAS UNIDADES DE APOYO LOGÍSTICO! ---

// 1. El Componente 'FormControl' para organizar nuestros filtros
@Composable
private fun FormControl(content: @Composable () -> Unit) {
    Div({
        style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
    }
    }) {
        content()
    }
}

// 2. La función de extensión 'toMonthName' para traducir números a nombres de meses
private fun Int.toMonthName(): String {
    return when(this) {
        1 -> "Enero"; 2 -> "Febrero"; 3 -> "Marzo"; 4 -> "Abril"; 5 -> "Mayo"; 6 -> "Junio";
        7 -> "Julio"; 8 -> "Agosto"; 9 -> "Septiembre"; 10 -> "Octubre";
        11 -> "Noviembre"; 12 -> "Diciembre"
        else -> ""
    }
}

// 3. La función de extensión para formatear el valor del Input de fecha
private fun Long.toDateInputValue(): String {
    val date = js("new Date(this)") // Usamos el constructor de JS Date
    val year = date.getFullYear()
    val month = (date.getMonth() + 1).toString().padStart(2, '0')
    val day = date.getDate().toString().padStart(2, '0')
    return "$year-$month-$day"
}



